(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveListSummaryWithPaymentReportController', ReserveListSummaryWithPaymentReportController);

    ReserveListSummaryWithPaymentReportController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CompanyCustom', 'DateUtils'];

    function ReserveListSummaryWithPaymentReportController($scope, ExportService, $uibModalInstance, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CompanyCustom, DateUtils) {
        var vm = this;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagStatus;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.downloadlink = '#';


        vm.orderBagStatusList = null;
        vm.orderBagStatus = "";
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.doBeforeExport = doBeforeExport;


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
            });
        }


        loadAll();

        function loadAll() {

            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                vm.serviceItems.push({id: 0, itemTitle: "همه خدمات"})
                vm.serviceItemId = 0;
                //if(items && items.length>0) {
                //
                //    vm.serviceItemId = items[0].id;
                //}
            });

            findCurrentCompany();

        }

        function confirm() {

            // vm.errorOnCreatingReport=true;
            // vm.reportCreatedAndDownload=false;
            // vm.errorOnCreatingReport=false;
            // var file = ExportService.export_excel_orderbag_list_by_service(vm.serviceItemId, vm.fromDateFilter, vm.toDateFilter, vm.orderBagStatus);
            // ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);

        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function doBeforeExport() {

            var report_config = {
                spname: 'sp_reserve_summary_with_payment_report',
                parameters: [{
                    name: 'p_company_id',
                    value: (vm.currentCompany.id) ? vm.currentCompany.id : 'null',
                    type: 'long'
                },
                    {name: 'p_status', value: (vm.orderBagStatus) ? vm.orderBagStatus : 'null', type: 'long'},
                    {name: 'p_service_id', value: (vm.serviceItemId) ? vm.serviceItemId : 'null', type: 'long'},
                    {name: 'p_from_date', value: DateUtils.convertToISOString(vm.fromDateFilter), type: 'date'},
                    {name: 'p_to_date', value: DateUtils.convertToISOString(vm.toDateFilter), type: 'date'}
                ]
            };
            return report_config;
        }
    }
})();
